import API from '../apis/API';
import urls from './urls';
import config from '../config';

let api = new API({ url: config.api.icebergApiUrl });
api.createEntities(urls)

export default api.endpoints;